import { render, staticRenderFns } from "./CadastroObservacaoTipo.vue?vue&type=template&id=753e384d&"
import script from "./CadastroObservacaoTipo.vue?vue&type=script&lang=js&"
export * from "./CadastroObservacaoTipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports